import { isMatriculaValida, isValidEmail } from "./helpers";

export const canSubmitColab = (username: string, password: string) =>
  isMatriculaValida(username) && password.trim().length > 0;

export const canSubmitForn = (username: string, password: string) =>
  isValidEmail(username) && password.trim().length > 0;
